export type BonusConditions = {
    events: ConditionDetail[];
    categories: ConditionDetail[];
    tournaments: ConditionDetail[];
    sports: ConditionDetail[];
    games: ConditionDetail[];
    bonusTicketType?: BonusTicketType;
    bonusEventType?: BonusEventType;
    minTotalOdd?: number;
    minEventOdd?: number;
};

export const BonusTicketType = {
    Single: 'single',
    Multiple: 'multiple',
} as const;
export type BonusTicketType = typeof BonusTicketType[keyof typeof BonusTicketType];

export const BonusEventType = {
    Mixed: 'mixed',
    Live: 'live',
    PreMatch: 'prematch',
} as const;
export type BonusEventType = typeof BonusEventType[keyof typeof BonusEventType];

export type ConditionDetail = {
    id: number;
    name: string;
};
